import Vue from 'vue';
import anime from 'animejs/lib/anime.es.js';

import App from './App'
import store from './store';

import TranslateManager from './managers/TranslateManager';

Vue.use(TranslateManager);

Vue.prototype.$anime = anime;
Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js